import React, { useState, useEffect, useCallback } from 'react';
import { getStates } from './Utils';
import AddressFields from './AddressFields';

const AddressForm = ({
  address: initialAddress,
  setAddress: setParentAddress,
  savedAddress,
  selectedAddress,
  setSelectedAddress,
  countries,
  cart,
  total,
  toggleContinueButton,
  setIsContinueDisabled, // Receive setIsContinueDisabled
}) => {
  const [address, setAddress] = useState(initialAddress || {});
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState({
    states: false,
  });

  useEffect(() => setParentAddress(address), [address, setParentAddress]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!address.country) return;
      setLoading((prev) => ({ ...prev, states: true }));
      try {
        const stateData = await getStates(address.country);
        setStates(stateData);
      } catch {
        setStates([]);
      } finally {
        setLoading((prev) => ({ ...prev, states: false }));
      }
    };
    fetchStates();
  }, [address.country]);

  // Enable/disable Continue button based on address selection
  useEffect(() => {
    if (selectedAddress === 'saved' && savedAddress) {
      const requiredFields = ['fullName', 'phone', 'house', 'number', 'street', 'district', 'city', 'state', 'postalCode', 'country'];
      const isValid = requiredFields.every((field) => savedAddress[field]?.trim());
      setIsContinueDisabled(!isValid);
    } else {
      setIsContinueDisabled(true); // Disable for new address until PIN verification
    }
  }, [selectedAddress, savedAddress, setIsContinueDisabled]);

  return (
    <div className="mt-10 p-6 bg-primary dark:bg-primary-dark text-black dark:text-white rounded-2xl shadow-lg border border-[#DBAE6E]">
      <h3 className="text-2xl font-bold mb-6 text-[#DBAE6E]">Delivery Address</h3>

      {savedAddress && (
        <div className={`p-4 mb-4 rounded-xl bg-primary dark:bg-primary-dark border-2 ${selectedAddress === 'saved' ? 'border-[#DBAE6E]' : 'border-gray-600'} bg-[#1a1a1a]`}>
          <label className="flex items-start space-x-4 cursor-pointer">
            <input
              type="radio"
              name="address"
              value="saved"
              checked={selectedAddress === 'saved'}
              onChange={() => setSelectedAddress('saved')}
              className="mt-1 accent-[#DBAE6E]"
            />
            <div>
              <p className="font-semibold">{savedAddress.fullName}, {savedAddress.phone}</p>
              <p className="text-sm text-gray-900">
                {savedAddress.street} {savedAddress.number}, {savedAddress.district}, {savedAddress.city},{' '}
                {savedAddress.state}, {savedAddress.postalCode}
              </p>
            </div>
          </label>
        </div>
      )}

      <label className="flex items-center space-x-3 mb-6 cursor-pointer">
        <input
          type="radio"
          name="address"
          value="new"
          checked={selectedAddress === 'new'}
          onChange={() => setSelectedAddress('new')}
          className="accent-[#DBAE6E]"
        />
        <span className="text-lg font-medium">Use New Address</span>
      </label>

      {selectedAddress === 'new' && (
        <div className="space-y-6">
          <AddressFields
            address={address}
            handleChange={handleChange}
            countries={countries}
            states={states}
            loadingStates={loading.states}
            toggleContinueButton={toggleContinueButton}
            setIsContinueDisabled={setIsContinueDisabled} // Pass to AddressFields
          />
        </div>
      )}
    </div>
  );
};

export default AddressForm;